"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NOTIFICATION_PREFERENCES_COPY = void 0;
exports.NOTIFICATION_PREFERENCES_COPY = {
    ALERTS_FOR_FOLLOWED_CHANGES: 'Alerts for Followed Metadata Changes',
    DAILY_SYNC_EMAIL: 'Daily Sync Email',
    EMAIL_WHEN_AT_MENTIONED: 'Email When @ Mentioned',
    SECTION_HEADER: 'Email Notifications'
};
//# sourceMappingURL=NOTIFICATION_PREFERENCES.js.map